export default __webpack_public_path__ + "static/media/donati-clever.84956fa8.svg";